import React from "react";
import nextId from "react-id-generator";
import { useHistory, useParams } from "react-router";
import Loading from "../../loading/Loading";
import { getBlockDataWithAuth } from "../../services/getAPIs";
import moment from "moment-timezone";
import { BlockMachine } from "../Context/Context";

export default function TransactionMoreInfo() {
  const { hash } = useParams();
  const history = useHistory();
  const [confidential, setConfidential] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const context = React.useContext(BlockMachine);
  const { loggedIn } = context;

  const setUpConfidential = async () => {
    let res;
    try {
      res = await getBlockDataWithAuth(hash);
      console.log("check", res)
      if (res.data.success) {
        setConfidential(res.data.data);
        setLoading(false);
      } else {
        setError(true);
        setLoading(false);
      }
    } catch (error) {
      setError(true);
      setLoading(false);
    }
  };

  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    setUpConfidential();
  }, []);
  return (
    <div className="transaction-more-info">
      {loading ? (
        <div className="more-info-loading">
          <Loading />
        </div>
      ) : error ? (
        <div className="more-info-error">
          <h4>
            <img src="https://img.icons8.com/flat-round/64/000000/error--v1.png" />
            Sorry, You are not authorized.
            <>
              {loggedIn ? (
                ""
              ) : (
                <>
                  To Explore More please
                  <span onClick={() => history.push("/login")}>
                    {" "}
                    login
                  </span>
                </>
              )}
            </>
          </h4>
        </div>
      ) : (
        <div className="more-info-data">
          {listOfData.map((obj) => (
            <div className="t-o-row">
              <p key={obj.keyId}>{obj.title}:</p>
              <p>
                {obj.id === "timeStamp"
                  ? moment(confidential[obj.id]).format("DD-MM-YYYY hh:mm a")
                  : obj.file
                  ? !confidential.fileInformation[obj.id]
                    ? "Not Available"
                    : confidential.fileInformation[obj.id]
                  : confidential[obj.id]}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const listOfData = [
  { keyId: nextId(), title: "Transaction Hash", id: "hash" },
  { keyId: nextId(), title: "Status", id: "status" },
  { keyId: nextId(), title: "File", id: "file", file: true },
  { keyId: nextId(), title: "File Name", id: "fileName", file: true },
  { keyId: nextId(), title: "File Size", id: "fileSize", file: true },

  { keyId: nextId(), title: "Timestamp", id: "timeStamp" },
  { keyId: nextId(), title: "Value", id: "data" },
  { keyId: nextId(), title: "By", id: "previousHash" },
  { keyId: nextId(), title: "Time Required", id: "timeRequired" },
  { keyId: nextId(), title: "Merkle Root", id: "merkleRoot" },
];
